import { Component } from '@angular/core';

@Component({
  selector: 'smart-fix-hub-page-wrapper',
  standalone: true,
  providers: [],
  imports: [],
  templateUrl: './hub-page-wrapper.component.html',
  styleUrls: ['./hub-page-wrapper.component.scss'],
})
export class HubPageWrapperComponent {
  constructor() {}
}
